import styled from 'styled-components';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

export const StyledFileListHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: '10px 16px',
  background: theme.colors.neutral['100'],
  borderTop: `1px solid ${theme.colors.neutral['200']}`,
  borderBottom: `1px solid ${theme.colors.neutral['200']}`,
}));
